import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-supervisor-admin',
  templateUrl: './create-supervisor-admin.component.html',
  styleUrls: ['./create-supervisor-admin.component.scss']
})
export class CreateSupervisorAdminComponent implements OnInit {

  displayedColumns = ['NOMBRE', 'BORRAR'];

  listaSub = [];
  dataSource;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateSupervisorAdminComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService
  ) { }
  
  operacion = 'creatadminsupervisor';
  identificador = '';
  idpais=5;
  areas = [];
  contratasagente = [];

  ngOnInit() {
    // this.idpais = this.data.supervidor.IDPAIS;
    this.getAreasAgente();
    this.getContratasAgente();

    // console.log('data:', this.data)
    if (this.data.operacion == 'Editar') {

      this.operacion = 'editadminsupervisor';
      this.identificador = this.data.supervisor.id;
      this.grupoVal.controls.NOMBRE.setValue(this.data.supervisor.nombre);
      this.grupoVal.controls.APELLIDO.setValue(this.data.supervisor.apellido);
      this.grupoVal.controls.CORREO.setValue(this.data.supervisor.correo);
      this.grupoVal.controls.PASS.setValue(this.data.supervisor.password);
      this.grupoVal.controls.PASS2.setValue(this.data.supervisor.password);
      this.grupoVal.controls.IDROL.setValue(this.data.supervisor.idrol);
      this.grupoVal.controls.CONTRATA_ID.setValue(this.data.supervisor.agente_contrata_id);
      this.grupoVal.controls.AREA_ID.setValue(this.data.supervisor.agente_area_id);

      this.onInputChange();
      this.onValueChanged(this.data.supervisor.idrol);
    }
  }

  getAreasAgente() {
    this.gateway.get('getAreasAgente', { NUM_PAGINA: 0, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.areas = aux.rows;
    }
    ).catch((e) => {
    });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', { NUM_PAGINA: 0, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.contratasagente = aux.rows;
    }
    ).catch((e) => {
    });
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let md5 = new Md5();
    this.spinner.show();
    let PARAMS = {
      ID: this.identificador,
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      APELLIDO: this.grupoVal.controls.APELLIDO.value.trim(),
      CORREO: this.grupoVal.controls.CORREO.value,
      PASS: md5.appendStr(this.grupoVal.controls.PASS.value).end(),
      IDROL: this.grupoVal.controls.IDROL.value,
      IDPAIS: this.idpais,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDADMIN: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,
      CONTRATA_ID: this.grupoVal.controls.IDROL.value == 23 ? (this.grupoVal.controls.CONTRATA_ID.value || null) : null,
      AREA_ID: this.grupoVal.controls.IDROL.value == 24 ? (this.grupoVal.controls.AREA_ID.value || null) : null,
    }

    if (this.data.operacion == 'Editar' && this.grupoVal.controls.PASS.value == this.data.supervisor.password) {
      // alert('entra')
      PARAMS.PASS = this.grupoVal.controls.PASS.value;
    }

    this.gateway.save(this.operacion, PARAMS).then((result) => {
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?["."#?!@$%^&*-])/;
  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    APELLIDO: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    CORREO: new FormControl('', Validators.compose([
      Validators.required, Validators.pattern("[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
    ])),
    PASS: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    ])),
    PASS2: new FormControl('', Validators.compose([
      Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
    ])),
    IDROL: new FormControl('', [Validators.compose([
      Validators.required
    ])]),
    CONTRATA_ID: new FormControl('', [Validators.compose([Validators.required])]),
    AREA_ID: new FormControl('', [Validators.compose([Validators.required])]),
  });

  roles = [
    { ID: 23, NOMBRE: 'Supervisor de Contratista' },
    { ID: 24, NOMBRE: 'Supervisor de Call Center' },
    { ID: 25, NOMBRE: 'Supervisor de Certificado de Nacimiento' }
  ];

  onValueChanged(option: any): void {
    // Aquí puedes ejecutar la lógica deseada
    if (option == 23) {
      this.grupoVal.get('CONTRATA_ID').setValidators(Validators.compose([Validators.required]))
      this.grupoVal.get('CONTRATA_ID').updateValueAndValidity();
      this.grupoVal.get('AREA_ID').clearValidators();
      this.grupoVal.get('AREA_ID').updateValueAndValidity();
    } else if(option == 24) {
      this.grupoVal.get('AREA_ID').setValidators(Validators.compose([Validators.required]))
      this.grupoVal.get('AREA_ID').updateValueAndValidity();
      this.grupoVal.get('CONTRATA_ID').clearValidators();
      this.grupoVal.get('CONTRATA_ID').updateValueAndValidity();
    } else{
      this.grupoVal.get('AREA_ID').clearValidators();
      this.grupoVal.get('AREA_ID').updateValueAndValidity();
      this.grupoVal.get('CONTRATA_ID').clearValidators();
      this.grupoVal.get('CONTRATA_ID').updateValueAndValidity();
    }
  }

  onInputChange() {
    if (this.data.operacion == 'Editar'
      && this.grupoVal.controls.PASS.value != ''
      && this.grupoVal.controls.PASS.value == this.data.supervisor.password) {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
      this.grupoVal.get('PASS2').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8)
      ]))
      this.grupoVal.get('PASS2').updateValueAndValidity();
    } else {
      this.grupoVal.get('PASS').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
      ]))
      this.grupoVal.get('PASS').updateValueAndValidity();
      this.grupoVal.get('PASS2').setValidators(Validators.compose([
        Validators.required, Validators.minLength(8), Validators.pattern(this.passwordRegex)
      ]))
      this.grupoVal.get('PASS2').updateValueAndValidity();
    }
  }

}
